import type { paramsTypeAllRequired } from '~~/shared/api/rurality/v3/search/cottages/schema'

const facetParams = ref<paramsTypeAllRequired | null>(null)

export function useFacetParams() {
  function setFacetParams(params: paramsTypeAllRequired) {
    facetParams.value = params
  }

  function getFacetParams(): paramsTypeAllRequired | null {
    return facetParams.value
  }

  function clearFacetParams() {
    facetParams.value = null
  }

  return {
    setFacetParams,
    getFacetParams,
    clearFacetParams,
  }
}
